import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=2564e3a2&"
import script from "./Admission.vue?vue&type=script&lang=js&"
export * from "./Admission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports